export default __webpack_public_path__ + "static/realestate-tab-5014479ca2331459d9daa1d8105f2521.png";